import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetProjectCodesAllSuspense } from '@/context/services/project_code/ProjectCode.service';
import { ProjectCode } from 'ap-openapi';

export const useFindProjectCodes = () => {
  const items = useGetProjectCodesAllSuspense();
  const findById = useFindById<ProjectCode, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useFindByName<ProjectCode, 'display_name', 'id'>(items, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findProjectCodesById: findById,
    findProjectCodesByName: findByName,
  };
};
